import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ArrowRightIcon, ExternalLinkIcon } from "@gemini/icons";
import { IS_SERVER } from "@/constants";
export const ProviderLink = ({ url, label, testId, toExternalSource = false, }) => {
    return (_jsxs(Box, { as: "a", testId: testId, cursor: "pointer", display: "flex", alignItems: "end", gap: "spacing.4", onClick: () => {
            if (IS_SERVER)
                return;
            window.open(url, "_blank");
        }, children: [_jsx(Box, { as: "span", marginTop: "spacing.8", typography: "typography.body.16.regularUnderlined", children: label }), toExternalSource ? _jsx(ExternalLinkIcon, {}) : _jsx(ArrowRightIcon, {})] }));
};
